import React from 'react';
import {createRoot} from 'react-dom/client';

import TopCategoriesModel from '../../models/top-categories-model';
import TopCategories from '../../components/footer/TopCategories.jsx';
import jshModule from '@core/scripts/helper/jsh-module';

const {moduleScope} = jshModule('article-overview-top-categories');

const topCategoriesModel = TopCategoriesModel.load(moduleScope);

createRoot(this.moduleScope).render(
    <TopCategories
        topCategoriesParam={topCategoriesModel.topCategories}
        texts={topCategoriesModel.configurationContent.texts}
    />
);
